<div class="mobile-phone-info">
  @if (isLoadingMobilePhoneOffering) {
    <div class="loading-container">
      <app-spinner />
    </div>
  } @else {
    @if (mobilePhoneVariant) {
      @if (mobilePhoneVariant.simTypeSupport === SimTypeSupport.Esim) {
        <app-ice-img-pill pillText="Kun eSIM">
          <img
            [ngClass]="{ 'short-image': isMinified() }"
            [src]="
              (mobilePhoneVariant.image && mobilePhoneVariant.image.previewUri) ||
              (selectedTheme$ | async).phone_slanted_illustration
            "
          />
        </app-ice-img-pill>
      } @else {
        <img
          [ngClass]="{ 'short-image': isMinified() }"
          [src]="
            (mobilePhoneVariant.image && mobilePhoneVariant.image.previewUri) ||
            (selectedTheme$ | async).phone_slanted_illustration
          "
        />
      }
      <div class="name">{{ mobilePhoneVariant.name }}</div>
      @if (!isMinified()) {
        <ul class="key-information">
          @for (item of mobilePhoneVariant.keyInformation; track $index) {
            <li>{{ item }}</li>
          }
        </ul>
      }
    } @else {
      <div class="phone-illustration-container">
        <img
          alt="Telefon"
          [ngClass]="{ 'short-image': isMinified() }"
          [src]="(selectedTheme$ | async).phone_slanted_illustration"
        />
      </div>
      @if (isManualRegistration) {
        <div class="name">{{ phoneName || 'Manuell registrering' }}</div>
      }
    }
    @if (webShopLink) {
      <a class="webshop-link" data-testid="mobilephone-webshop-link" target="_blank" [href]="webShopLink">
        Les mer i nettbutikken
      </a>
    }
  }
</div>
